var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemTorusElement_1;
import { CustomElement, P, Watch, PropertyConverters } from '@pacem/pacem-core';
import { computeSharpVertexNormals } from '../types';
import { MeshGeometry } from '../geometry';
import { Pacem3DPrimitiveElement } from './primitive';
import { TAG_MIDDLE_NAME, DEG2RAD } from '../constants';
//namespace Pacem.Components.Drawing3D {
let PacemTorusElement = PacemTorusElement_1 = class PacemTorusElement extends Pacem3DPrimitiveElement {
    static createMeshGeometry(radius = 1, innerRadius = .25, segments = 24, sides = 12) {
        //
        const nodes = [];
        const uv = [];
        const coords = [];
        const theta = DEG2RAD * (360.0 / segments);
        const phi = DEG2RAD * (360.0 / sides);
        const r1 = radius;
        const r2 = innerRadius;
        for (let j = 0; j < segments; j++) {
            // Math.PI/2 adjustement (useful for UV mapping)
            const angle1 = theta * j - Math.PI / 2.0;
            const sin_angle1 = Math.sin(angle1);
            const cos_angle1 = Math.cos(angle1);
            for (let i = 0; i < sides; i++) {
                // Math.PI adjustement (useful for UV mapping)
                const angle2 = phi * i + Math.PI;
                const cos_angle2 = Math.cos(angle2);
                const x = r1 * cos_angle1 + r2 * cos_angle2 * cos_angle1;
                const y = r2 * Math.sin(angle2);
                const z = r1 * sin_angle1 + r2 * cos_angle2 * sin_angle1;
                nodes.push({ x, y, z });
                const prev_j = j > 0 ? j - 1 : segments - 1;
                const prev_i = i > 0 ? i - 1 : sides - 1;
                const u = j == 0 ? .0 : 1.0 - 1.0 * j / segments;
                const v = i > 0 ? 1.0 * i / sides : 1.0;
                const u_prev = j > 0 ? 1.0 - (j - 1.0) / segments : 1.0 / segments;
                const v_prev = i > 0 ? (i - 1.0) / sides : 1.0 - 1.0 / sides;
                // triangles <=> Int32Collection
                //           <=> PointCollection
                coords.push(j * sides + prev_i);
                coords.push(prev_j * sides + prev_i);
                coords.push(prev_j * sides + i);
                coords.push(j * sides + prev_i);
                coords.push(prev_j * sides + i);
                coords.push(j * sides + i);
                //
                uv.push({ x: u, y: v_prev });
                uv.push({ x: u_prev, y: v_prev });
                uv.push({ x: u_prev, y: v });
                uv.push({ x: u, y: v_prev });
                uv.push({ x: u_prev, y: v });
                uv.push({ x: u, y: v });
            }
        }
        const geom = new MeshGeometry(nodes, coords, uv);
        geom.key = `torus_${radius}x${innerRadius}_t${segments}_s${sides}`;
        computeSharpVertexNormals(geom);
        return geom;
    }
    createDefaultGeometry() {
        return PacemTorusElement_1.createMeshGeometry();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'radius':
            case 'innerRadius':
            case 'segments':
            case 'sides':
                this.geometry = PacemTorusElement_1.createMeshGeometry(this.radius, this.innerRadius, this.segments, this.sides);
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTorusElement.prototype, "radius", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTorusElement.prototype, "innerRadius", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTorusElement.prototype, "segments", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTorusElement.prototype, "sides", void 0);
PacemTorusElement = PacemTorusElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-primitive-torus' })
], PacemTorusElement);
export { PacemTorusElement };
